import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-63d07b60"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: "modal is-active",
  ref: "paymentConfirmation"
}
const _hoisted_2 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "modal-background" }, null, -1))
const _hoisted_3 = { class: "modal-card" }
const _hoisted_4 = { class: "modal-card-title is-title-shrink" }
const _hoisted_5 = { class: "modal-card-body" }
const _hoisted_6 = { class: "body-content is-size-4" }
const _hoisted_7 = {
  key: 0,
  class: "mt-2 mb-5 is-size-5 notification is-danger is-light"
}
const _hoisted_8 = { class: "custom-card-title has-text-weight-bold" }
const _hoisted_9 = {
  key: 1,
  class: "confirm-icon-container mb-2"
}
const _hoisted_10 = {
  key: 2,
  class: "confirm-icon-container"
}
const _hoisted_11 = ["innerHTML"]
const _hoisted_12 = {
  key: 4,
  class: "amount has-text-weight-bold is-size-4"
}
const _hoisted_13 = { key: 5 }
const _hoisted_14 = { key: 0 }
const _hoisted_15 = {
  key: 0,
  class: "frame3-sub-title"
}
const _hoisted_16 = { key: 0 }
const _hoisted_17 = { class: "frame3-sub-title" }
const _hoisted_18 = { class: "frame3-sub-title has-text-weight-bold is-size-3 hide-overflow" }
const _hoisted_19 = { key: 1 }
const _hoisted_20 = { class: "frame3-sub-title" }
const _hoisted_21 = { class: "frame3-sub-title has-text-weight-bold is-size-3 hide-overflow" }
const _hoisted_22 = { class: "frame3-sub-title mb-3" }
const _hoisted_23 = { key: 6 }
const _hoisted_24 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("hr", null, null, -1))
const _hoisted_25 = { class: "transaction-list-description" }
const _hoisted_26 = { class: "modal-card-foot custom-modal-card-foot is-justify-content-flex-end" }
const _hoisted_27 = {
  key: 0,
  class: "ml-2 mr-2"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_fa_icon = _resolveComponent("fa-icon")!
  const _component_TransactionItem = _resolveComponent("TransactionItem")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("header", {
        class: _normalizeClass(["modal-card-head", _ctx.$modal.args?.value[0].type])
      }, [
        _createElementVNode("p", _hoisted_4, _toDisplayString({
              transactionDetail: _ctx.$gettext("Transaction details"),
              paymentConfirmation: _ctx.$gettext("Payment confirmation"),
              topup: _ctx.$gettext("Top-up details"),
              reconversion: _ctx.$gettext("Reconversion details"),
            }[_ctx.$modal.args?.value[0].type]), 1),
        _createElementVNode("button", {
          class: "delete",
          "aria-label": "close",
          onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$modal.close()))
        })
      ], 2),
      _createElementVNode("section", _hoisted_5, [
        _createElementVNode("div", _hoisted_6, [
          (_ctx.$modal.args?.value[0]?.source == 'askTopUp')
            ? (_openBlock(), _createElementBlock("p", _hoisted_7, _toDisplayString(_ctx.$gettext(
                "You already have a pending top-up. Please either pay or delete it before proceeding"
              )), 1))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_8, _toDisplayString({
                transactionDetail: _ctx.$modal.args?.value[0].transaction.pending
                  ? _ctx.$gettext("Transaction sent")
                  : _ctx.$gettext("Transaction processed"),
                paymentConfirmation: _ctx.$gettext("Payment sent"),
                topup:
                  typeof _ctx.$modal.args?.value[0].transaction.cancel !==
                  "undefined"
                    ? _ctx.$gettext("Top-up requested")
                    : _ctx.$gettext("Top-up received"),
                reconversion: _ctx.reconversionStatus,
              }[_ctx.$modal.args?.value[0].type]), 1),
          (_ctx.$modal.args?.value[0].type == 'topup')
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createVNode(_component_fa_icon, {
                  icon: "plus-circle",
                  class: "confirm-icon fa-thin"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createVNode(_component_fa_icon, {
                  icon: "fa-check",
                  class: "confirm-icon fa-thin"
                })
              ])),
          (_ctx.$modal.args?.value[0].type != 'topup')
            ? (_openBlock(), _createElementBlock("p", {
                key: 3,
                class: _normalizeClass(["amount has-text-weight-bold is-size-4", {
              cm: _ctx.transactionsTags.includes('barter'),
            }]),
                innerHTML: _ctx.amountSentence
              }, null, 10, _hoisted_11))
            : (_openBlock(), _createElementBlock("p", _hoisted_12, _toDisplayString(((t) =>
                typeof t.cancel !== "undefined"
                  ? _ctx.$gettext("Requested %{amount}", {
                      amount: `${_ctx.numericFormat(t.amount)} ${t.currency}`,
                    })
                  : _ctx.$gettext("Received %{amount}", {
                      amount: `${_ctx.numericFormat(t.amount)} ${t.currency}`,
                    }))(_ctx.$modal.args?.value[0].transaction)), 1)),
          (_ctx.$modal.args?.value[0].type !== 'reconversion')
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                (_ctx.$modal.args?.value[0].transaction.isTopUp)
                  ? (_openBlock(), _createElementBlock("h2", _hoisted_14, [
                      (_ctx.$modal.args?.value[0].type == 'topup')
                        ? (_openBlock(), _createElementBlock("h2", _hoisted_15, [
                            _createTextVNode(_toDisplayString(_ctx.$modal.args?.value[0].transaction.paid === true
                    ? _ctx.$gettext(
                        "This top-up request is waiting for an administrator of your local currency to validate it"
                      )
                    : typeof _ctx.$modal.args?.value[0].transaction.cancel !==
                        "undefined" &&
                      _ctx.$modal.args?.value[0].transaction.paid === false &&
                      _ctx.$modal.args?.value[0].account.isTopUpAllowed &&
                      (_ctx.$modal.args?.value[0].transaction.requester ===
                        undefined ||
                        _ctx.$modal.args?.value[0].transaction.requester.id ===
                          _ctx.userProfile.id)
                    ? _ctx.$gettext(
                        "Your top-up request is waiting for you to pay it or delete it"
                      )
                    : "") + " ", 1),
                            (
                    _ctx.$modal.args?.value[0].transaction.requester !== undefined &&
                    _ctx.$modal.args?.value[0].transaction.requester.id !==
                      _ctx.userProfile.id
                  )
                              ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                                  _createElementVNode("h2", _hoisted_17, _toDisplayString(_ctx.$gettext("by")), 1),
                                  _createElementVNode("p", _hoisted_18, _toDisplayString(_ctx.$modal.args?.value[0].transaction.requester.name), 1)
                                ]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  : (_openBlock(), _createElementBlock("h2", _hoisted_19, [
                      _createElementVNode("h2", _hoisted_20, _toDisplayString(_ctx.transactionTotalAmount < 0 ? _ctx.$gettext("to") : _ctx.$gettext("from")), 1),
                      _createElementVNode("p", _hoisted_21, _toDisplayString(_ctx.transactions[0].related), 1)
                    ]))
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("p", _hoisted_22, _toDisplayString(_ctx.dateFormat), 1),
          (_ctx.transactions.length > 1)
            ? (_openBlock(), _createElementBlock("div", _hoisted_23, [
                _hoisted_24,
                _createElementVNode("div", _hoisted_25, _toDisplayString(this.$gettext(
                  "Payment was done in %{nbTransactions} transactions:",
                  { nbTransactions: _ctx.transactions.length }
                )), 1),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.transactions, (transaction) => {
                  return (_openBlock(), _createBlock(_component_TransactionItem, {
                    key: transaction,
                    transaction: transaction,
                    mode: "small"
                  }, null, 8, ["transaction"]))
                }), 128))
              ]))
            : _createCommentVNode("", true)
        ])
      ]),
      _createElementVNode("footer", _hoisted_26, [
        (
            _ctx.$modal.args?.value[0].type == 'topup' &&
            _ctx.$modal.args?.value[0].transaction.paid === false &&
            _ctx.$modal.args?.value[0].account.isTopUpAllowed &&
            (_ctx.$modal.args?.value[0].transaction?.requester === undefined ||
              _ctx.$modal.args?.value[0].transaction?.requester?.id ===
                this.userProfile.id)
          )
          ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
              _createElementVNode("button", {
                class: "button custom-button-modal has-text-weight-medium",
                id: "delete",
                onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.cancelTopUpRequest && _ctx.cancelTopUpRequest(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Delete")), 1)
              ]),
              _createElementVNode("button", {
                class: "button custom-button-modal has-text-weight-medium",
                onClick: _cache[2] || (_cache[2] = 
//@ts-ignore
(...args) => (_ctx.payTopUpRequest && _ctx.payTopUpRequest(...args)))
              }, [
                _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Pay")), 1)
              ])
            ]))
          : _createCommentVNode("", true),
        _createElementVNode("button", {
          class: "button custom-button-modal has-text-weight-medium",
          onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.$modal.close()))
        }, [
          _createElementVNode("span", null, _toDisplayString(_ctx.$gettext("Ok")), 1)
        ])
      ])
    ])
  ], 512))
}